import React, { JSX } from 'react';
import {
    BarChart3,
    PieChart,
    LineChart,
    AreaChart,
    Radar,
    Columns3,
    X
} from 'lucide-react';

export type ChartType = 'bar' | 'pie' | 'line' | 'area' | 'doughnut' | 'radar' | 'table';

interface GraphSelectorModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSelect: (type: ChartType) => void;
}

const chartOptions: { type: ChartType; label: string; icon: JSX.Element }[] = [
    { type: 'bar', label: 'Bar Chart', icon: <BarChart3 className="w-6 h-6 text-blue-600" /> },
    { type: 'line', label: 'Line Chart', icon: <LineChart className="w-6 h-6 text-green-600" /> },
    { type: 'area', label: 'Area Chart', icon: <AreaChart className="w-6 h-6 text-teal-600" /> },
    { type: 'pie', label: 'Pie Chart', icon: <PieChart className="w-6 h-6 text-pink-600" /> },
    { type: 'doughnut', label: 'Doughnut Chart', icon: <PieChart className="w-6 h-6 text-indigo-500" /> },
    { type: 'radar', label: 'Radar Chart', icon: <Radar className="w-6 h-6 text-amber-500" /> },
    { type: 'table', label: 'Table View', icon: <Columns3 className="w-6 h-6 text-indigo-500" /> }

];

const GraphSelectorModal: React.FC<GraphSelectorModalProps> = ({ isOpen, onClose, onSelect }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6 relative">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 p-1 rounded hover:bg-gray-100"
                    aria-label="Close"
                >
                    <X className="w-5 h-5 text-gray-600" />
                </button>

                <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
                    Select a Chart Type
                </h2>

                {/* Chart Options */}
                <div className="grid grid-cols-2 gap-4">
                    {chartOptions.map((chart) => (
                        <button
                            key={chart.type}
                            onClick={() => {
                                onSelect(chart.type);
                                onClose();
                            }}
                            className="flex flex-col items-center justify-center border border-gray-200 rounded-lg p-4 hover:shadow-md hover:border-blue-500 transition-all bg-gray-50 hover:bg-white"
                        >
                            {chart.icon}
                            <span className="text-sm mt-2 text-gray-700">{chart.label}</span>
                        </button>
                    ))}
                </div>

                {/* Separator */}
                <div className="border-t mt-6 mb-4" />

            </div>
        </div>
    );
};

export default GraphSelectorModal;
